<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="场站大类（可多选）：">
            <el-select v-model="formInline.stationTypes" multiple clearable placeholder="请选择" style="width: 180px;" collapse-tags collapse-tags-tooltip>
                <el-option label="高速" :value="1"></el-option>
                <el-option label="市区" :value="2"></el-option>
                <el-option label="内部" :value="3"></el-option>
                <!-- <el-option label="社区" :value="4"></el-option> -->
            </el-select>
        </el-form-item>
        <el-form-item label="场站（可多选）：">
            <el-select v-model="formInline.stationIds" multiple filterable clearable placeholder="请选择场站" style="width: 200px;" collapse-tags collapse-tags-tooltip>
                <el-option
                    v-for="item in stationOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="用户类型：">
            <el-select v-model="formInline.userTypes" multiple clearable placeholder="请选择" style="width: 180px;" collapse-tags collapse-tags-tooltip>
                <el-option label="个人预付费" :value="0"></el-option>
                <el-option label="企业预付费" :value="1"></el-option>
                <el-option label="企业后付费" :value="2"></el-option>
                <el-option label="个人后付费" :value="4"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="汇总周期：">
            <el-select v-model="formInline.timeType" placeholder="请选择" style="width: 120px;" @change="handleTimeTypeChange">
                <el-option label="日" :value="1"></el-option>
                <el-option label="月" :value="2"></el-option>
                <el-option label="季度" :value="3"></el-option>
                <el-option label="年" :value="4"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="时间范围：">
            <el-select v-model="formInline.dateType" placeholder="请选择" style="width: 150px; margin-right: 8px;">
                <el-option label="充电开始时间" :value="1"></el-option>
                <el-option label="充电结束时间" :value="2"></el-option>
            </el-select>
            <el-date-picker
                v-if="formInline.timeType === 1"
                v-model="formInline.dateRange"
                type="datetimerange"
                value-format="YYYY-MM-DD HH:mm:ss"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 380px;"
            />
            <el-date-picker
                v-else-if="formInline.timeType === 2"
                v-model="formInline.dateRange"
                type="monthrange"
                value-format="YYYY-MM"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                style="width: 380px;"
            />
            <div v-else-if="formInline.timeType === 3" style="display: flex; align-items: center; gap: 8px;">
                <el-select v-model="formInline.startQuarter" placeholder="开始季度" style="width: 150px;">
                    <el-option
                        v-for="item in quarterOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <span>至</span>
                <el-select v-model="formInline.endQuarter" placeholder="结束季度" style="width: 150px;">
                    <el-option
                        v-for="item in quarterOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-date-picker
                v-else-if="formInline.timeType === 4"
                v-model="formInline.dateRange"
                type="yearrange"
                value-format="YYYY"
                range-separator="至"
                start-placeholder="开始年份"
                end-placeholder="结束年份"
                style="width: 380px;"
            />
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="primary" @click="exportSummary">导出汇总表</el-button>
            <el-button v-if="showExportDetail" type="primary" @click="exportDetail">导出明细表</el-button>
        </el-form-item>
    </el-form>

    <div class="summary-box" v-if="summaryData">
        <el-row :gutter="16">
            <el-col :span="4">
                <div class="summary-item">
                    <div class="summary-icon">⚡</div>
                    <div class="summary-label">累计充电量</div>
                    <div class="summary-value">{{ summaryData.chargeQuantity || 0 }} <span class="unit">kWh</span></div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="summary-item">
                    <div class="summary-icon">💰</div>
                    <div class="summary-label">实收金额</div>
                    <div class="summary-value">{{ summaryData.receivedAmount || 0 }} <span class="unit">元</span></div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="summary-item">
                    <div class="summary-icon">🔌</div>
                    <div class="summary-label">实收充电电费</div>
                    <div class="summary-value">{{ summaryData.electricityFee || 0 }} <span class="unit">元</span></div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="summary-item">
                    <div class="summary-icon">📊</div>
                    <div class="summary-label">实收充电服务费</div>
                    <div class="summary-value">{{ summaryData.discSvcFee || 0 }} <span class="unit">元</span></div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="summary-item" @click="handleChargeCountClick">
                    <div class="summary-icon">🔋</div>
                    <div class="summary-label">累计充电次数</div>
                    <div class="summary-value">{{ summaryData.chargeCount || 0 }} <span class="unit">次</span></div>
                </div>
            </el-col>
        </el-row>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="运营周期" min-width="150" show-overflow-tooltip>
            <template #default="scope">
                <span :style="{ fontWeight: scope.row.summaryRow ? 'bold' : 'normal' }">{{ scope.row.operationPeriod }}</span>
            </template>
        </el-table-column>
        <el-table-column label="累计总充电量(kWh)" min-width="200">
            <template #default="scope">
                <span>{{ scope.row.chargeQuantity || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="累计充电时长" min-width="130">
            <template #default="scope">
                <span>{{ formatDuration(scope.row.durationMinute) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实收金额(元)" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.receivedAmount || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实收充电电费(元)" min-width="200">
            <template #default="scope">
                <span>{{ scope.row.electricityFee || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="折前服务费(元)" min-width="160">
            <template #default="scope">
                <span>{{ scope.row.serviceFee || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实收充电服务费(元)" min-width="200">
            <template #default="scope">
                <span>{{ scope.row.discSvcFee || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="累计充电次数(次)" min-width="200">
            <template #default="scope">
                <span>{{ scope.row.chargeCount || 0 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="平均充电量(kWh/次)" min-width="180">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '' : (scope.row.averageChargeQuantity || 0) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="平均充电功率(kW)" min-width="200">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '' : (scope.row.averagePower || 0) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="平均充电时长" min-width="130">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '' : formatDuration(scope.row.averageDurationMinute) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电桩数量" min-width="120">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '' : (scope.row.gunCount || 0) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="时间利用率(%)" min-width="130">
            <template #default="scope">
                <span>{{ scope.row.summaryRow ? '' : (scope.row.timeUtilization || 0) }}</span>
            </template>
        </el-table-column>
    </el-table>

    <Pagination
        v-model:current-page="page"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
</template>

<script>
import { ElMessage } from 'element-plus';

export default {
    name: 'PeriodicData',
    data() {
        const now = new Date();
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const endTimeWithBuffer = new Date(now.getTime() - 5 * 60 * 1000); // Subtract 5 minutes buffer for server time difference
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };
        
        const currentYear = now.getFullYear();
        const quarterOptions = [];
        for (let year = currentYear - 2; year <= currentYear; year++) {
            for (let quarter = 1; quarter <= 4; quarter++) {
                quarterOptions.push({
                    label: `${year}年Q${quarter}`,
                    value: `${year}-Q${quarter}`
                });
            }
        }
        
        return {
            stationOptions: [],
            formInline: {
                stationTypes: [],
                stationIds: [],
                userTypes: [],
                timeType: 1,
                dateType: 2,
                dateRange: [formatDate(todayStart), formatDate(endTimeWithBuffer)],
                startQuarter: '',
                endQuarter: '',
            },
            quarterOptions: quarterOptions,
            tableData: [],
            summaryData: null,
            page: 1,
            pageSize: 20,
            total: 0,
            showExportDetail: false, // 导出明细表按钮默认隐藏，2秒内连点累计充电次数5次显示
            detailClickStamps: [],
        }
    },
    mounted() {
        this.getStationOptions();
        this.getList();
    },
    watch: {
        '$store.state.stationList': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.getStationOptions();
                }
            },
            immediate: true
        },
        'formInline.stationTypes': {
            handler(newVal, oldVal) {
                // 如果选中项减少，清除对应类型的场站
                if (oldVal && oldVal.length > 0 && newVal && newVal.length < oldVal.length) {
                    const removedTypes = oldVal.filter(type => !newVal.includes(type));
                    const allStations = this.$store.state.stationList || [];
                    // 找出被移除类型对应的场站ID
                    const removedStationIds = allStations
                        .filter(station => removedTypes.includes(Number(station.type)))
                        .map(station => station.id);
                    // 从已选场站中清除这些ID
                    this.formInline.stationIds = this.formInline.stationIds.filter(id => !removedStationIds.includes(id));
                }
                this.getStationOptions();
            }
        }
    },
    methods: {
        formatDuration(minutes) {
            if (!minutes || minutes === 0) return '0分钟';
            const mins = Math.round(minutes);
            const hours = Math.floor(mins / 60);
            const remainingMins = mins % 60;
            if (hours > 0) {
                return `${hours}时${remainingMins}分`;
            }
            return `${remainingMins}分钟`;
        },
        getStationOptions() {
            const allStations = this.$store.state.stationList || [];
            if (this.formInline.stationTypes && this.formInline.stationTypes.length > 0) {
                this.stationOptions = allStations.filter(station =>
                    this.formInline.stationTypes.includes(Number(station.type))
                    && Number(station.state) !== 1
                );
            } else {
                this.stationOptions = [];
            }
        },
        handleTimeTypeChange() {
            this.formInline.dateRange = [];
            this.formInline.startQuarter = '';
            this.formInline.endQuarter = '';
        },
        getTimeParams() {
            if (this.formInline.timeType === 3) {
                if (!this.formInline.startQuarter || !this.formInline.endQuarter) {
                    return {};
                }
                const startParts = this.formInline.startQuarter.split('-Q');
                const endParts = this.formInline.endQuarter.split('-Q');
                const startYear = parseInt(startParts[0]);
                const startQuarter = parseInt(startParts[1]);
                const endYear = parseInt(endParts[0]);
                const endQuarter = parseInt(endParts[1]);
                
                const startMonth = (startQuarter - 1) * 3 + 1;
                const endMonth = endQuarter * 3;
                
                const startTime = `${startYear}-${String(startMonth).padStart(2, '0')}-01 00:00:00`;
                const lastDay = new Date(endYear, endMonth, 0).getDate();
                const endTime = `${endYear}-${String(endMonth).padStart(2, '0')}-${lastDay} 23:59:59`;
                
                return { startTime, endTime };
            }
            
            if (!this.formInline.dateRange || this.formInline.dateRange.length !== 2) {
                return {};
            }
            
            if (this.formInline.timeType === 2) {
                const startTime = `${this.formInline.dateRange[0]}-01 00:00:00`;
                const endDate = new Date(this.formInline.dateRange[1] + '-01');
                const lastDay = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).getDate();
                const endTime = `${this.formInline.dateRange[1]}-${String(lastDay).padStart(2, '0')} 23:59:59`;
                return { startTime, endTime };
            }
            
            if (this.formInline.timeType === 4) {
                const startTime = `${this.formInline.dateRange[0]}-01-01 00:00:00`;
                const endTime = `${this.formInline.dateRange[1]}-12-31 23:59:59`;
                return { startTime, endTime };
            }
            
            return {
                startTime: this.formInline.dateRange[0],
                endTime: this.formInline.dateRange[1],
            };
        },
        getList() {
            let that = this;
            let param = {
                page: that.page,
                pageSize: that.pageSize,
                timeType: that.formInline.timeType,
                dateType: that.formInline.dateType,
            };
            if (that.formInline.stationTypes.length > 0) {
                param.stationTypes = that.formInline.stationTypes;
            }
            if (that.formInline.stationIds.length > 0) {
                param.stationIds = that.formInline.stationIds;
            }
            if (that.formInline.userTypes.length > 0) {
                param.userTypes = that.formInline.userTypes;
            }
            const timeParams = that.getTimeParams();
            if (timeParams.startTime && timeParams.endTime) {
                param.startTime = timeParams.startTime;
                param.endTime = timeParams.endTime;
            }
            that.$axios.post("bi-server/report/period-summary/page", JSON.stringify(param)).then(result => {
                if (result.code === 200 && result.data) {
                    that.summaryData = result.data.summary || null;
                    if (result.data.page) {
                        that.tableData = result.data.page.records || [];
                        that.total = result.data.page.total || 0;
                    }
                }
            });
        },
        exportSummary() {
            let that = this;
            let param = {
                timeType: that.formInline.timeType,
                dateType: that.formInline.dateType,
            };
            if (that.formInline.stationTypes.length > 0) {
                param.stationTypes = that.formInline.stationTypes;
            }
            if (that.formInline.stationIds.length > 0) {
                param.stationIds = that.formInline.stationIds;
            }
            if (that.formInline.userTypes.length > 0) {
                param.userTypes = that.formInline.userTypes;
            }
            const timeParams = that.getTimeParams();
            if (timeParams.startTime && timeParams.endTime) {
                param.startTime = timeParams.startTime;
                param.endTime = timeParams.endTime;
            }
            that.$axios.post("bi-server/report/period-summary/export/summary", JSON.stringify(param), {responseType: 'blob'}).then(result => {
                if (result instanceof Blob) {
                    if (result.type && result.type.includes('application/json')) {
                        const reader = new FileReader();
                        reader.onload = () => {
                            try {
                                const errorMsg = JSON.parse(reader.result);
                                ElMessage.error(errorMsg.message || errorMsg.msg || '导出失败');
                            } catch (e) {
                                ElMessage.error('导出失败');
                            }
                        };
                        reader.readAsText(result);
                    } else {
                        ElMessage.success('导出成功');
                    }
                } else if (result.code !== 200) {
                    ElMessage.error(result.message || '导出失败');
                }
            }).catch(error => {
                if (error.response && error.response.data) {
                    const blob = error.response.data;
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const errorMsg = JSON.parse(reader.result);
                            ElMessage.error(errorMsg.message || errorMsg.msg || '导出失败');
                        } catch (e) {
                            ElMessage.error('导出失败');
                        }
                    };
                    reader.readAsText(blob);
                } else {
                    ElMessage.error('导出失败');
                }
            });
        },
        exportDetail() {
            let that = this;
            if (that.formInline.stationIds.length === 0) {
                ElMessage.warning('请先选择场站');
                return;
            }
            if (that.formInline.stationIds.length > 10) {
                ElMessage.warning('明细表最多只能导出10个场站，请减少选择的场站数量');
                return;
            }
            let param = {
                timeType: that.formInline.timeType,
                dateType: that.formInline.dateType,
            };
            if (that.formInline.stationTypes.length > 0) {
                param.stationTypes = that.formInline.stationTypes;
            }
            param.stationIds = that.formInline.stationIds;
            if (that.formInline.userTypes.length > 0) {
                param.userTypes = that.formInline.userTypes;
            }
            const timeParams = that.getTimeParams();
            if (timeParams.startTime && timeParams.endTime) {
                param.startTime = timeParams.startTime;
                param.endTime = timeParams.endTime;
            }
            that.$axios.post("bi-server/report/period-summary/export/detail", JSON.stringify(param), {responseType: 'blob'}).then(result => {
                if (result instanceof Blob) {
                    if (result.type && result.type.includes('application/json')) {
                        const reader = new FileReader();
                        reader.onload = () => {
                            try {
                                const errorMsg = JSON.parse(reader.result);
                                ElMessage.error(errorMsg.message || errorMsg.msg || '导出失败');
                            } catch (e) {
                                ElMessage.error('导出失败');
                            }
                        };
                        reader.readAsText(result);
                    } else {
                        ElMessage.success('导出成功');
                    }
                } else if (result.code !== 200) {
                    ElMessage.error(result.message || '导出失败');
                }
            }).catch(error => {
                if (error.response && error.response.data) {
                    const blob = error.response.data;
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const errorMsg = JSON.parse(reader.result);
                            ElMessage.error(errorMsg.message || errorMsg.msg || '导出失败');
                        } catch (e) {
                            ElMessage.error('导出失败');
                        }
                    };
                    reader.readAsText(blob);
                } else {
                    ElMessage.error('导出失败');
                }
            });
        },
        handleChargeCountClick() {
            if (this.showExportDetail) return;
            const now = Date.now();
            // 滑动窗口：只统计最近2秒内的点击
            this.detailClickStamps = this.detailClickStamps.filter(t => now - t < 2000);
            this.detailClickStamps.push(now);
            if (this.detailClickStamps.length >= 5) {
                this.showExportDetail = true;
                this.detailClickStamps = [];
                ElMessage.success('已开启导出明细表');
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
    }
}
</script>

<style lang="scss" scoped>
/* 搜索表单无 search_nav 包裹（模板根节点）；全局标签 96px 放不下"场站大类（可多选）："，放宽到 154px；
   用 .demo-form-inline.el-form 提高优先级，否则会被后注入的 global-search.css 同优先级规则压回 */
.demo-form-inline.el-form :deep(.el-form-item__label) {
    width: 154px;
    min-width: 154px;
}
.summary-box {
    background-color: #f5f7fa;
    padding: 12px 16px;
    margin-bottom: 16px;
    border-radius: 6px;
}
.summary-item {
    background: #ffffff;
    padding: 12px 10px;
    border-radius: 6px;
    text-align: center;
    transition: all 0.3s ease;
    border: 1px solid #e4e7ed;
    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        transform: translateY(-2px);
    }
    &.highlight {
        border-color: #409eff;
        background: #ecf5ff;
        .summary-value {
            color: #409eff;
        }
    }
}
.summary-icon {
    font-size: 20px;
    margin-bottom: 4px;
}
.summary-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
}
.summary-value {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
    .unit {
        font-size: 12px;
        font-weight: normal;
        color: #909399;
    }
}
</style>